import React from "react";
import {
  CheckListTemplateFragmentFragment,
  Company,
  ItemFilters,
  ItemFragmentFragment,
  ProjectFragmentFragment,
  TaskFragmentFragment,
  UserFragment,
} from "@/graphql/types";

export type LoaderPlace =
  | "copy_card"
  | "new_task"
  | "new_action"
  | "delete_task"
  | "close_task"
  | "none";

export type MelaContext = {
  isLoading: boolean;
  loader: boolean;
  setLoader: (value: boolean) => void;
  loaderPlace: LoaderPlace;
  setLoaderPlace: (value: LoaderPlace) => void;
  isAuthenticated: boolean;
  user: UserFragment;
  company: Company;
  setCompany: (value: Company) => void;
  isBusinessAnalyst: boolean;
  isUserAccountant: boolean;
  isCompanyAdmin: boolean;
  canAccessSettings: boolean;
  companyCurrency: string;
  project: ProjectFragmentFragment;
  setProject: (value: ProjectFragmentFragment) => void;
  search: boolean;
  setSearch: (search: boolean) => void;
  q: string;
  setQ: (q: string) => void;
  filters: Partial<ItemFilters>;
  setFilters: (filters) => void;
  showSearchHeader: boolean;
  setShowSearchHeader: (val: boolean) => void;
  showSearchFilters: boolean;
  setShowSearchFilters: (val: boolean) => void;
  version: string;
  setVersion: (value: React.SetStateAction<string>) => void;
  skipUsage: boolean;
  setSkipUsage: (value: React.SetStateAction<boolean>) => void;
  updatePicture: () => void;
  task: {
    data?: TaskFragmentFragment;
    clear: () => void;
    set: (data: TaskFragmentFragment) => void;
  };
  selection: {
    active: boolean;
    toggle: () => void;
    data: ItemFragmentFragment[];
    keys: string[];
    add: (data: ItemFragmentFragment) => void;
    remove: (data: ItemFragmentFragment) => void;
    set: (data: ItemFragmentFragment[]) => void;
    clear: () => void;
  };
  checklists: CheckListTemplateFragmentFragment[];
  setChecklists: any;
  taskContainerDimension: { width: number; height: number };
  setTaskContainerDimension: (value: { width: number; height: number }) => void;
  isSidebarUpdateModalOpen: boolean;
  setSidebarUpdateModalOpen: (value: boolean) => void;
  sidebarHighlightedArea: { y: number; height: number } | null;
  setSidebarHighlightedArea: (
    value: { y: number; height: number } | null,
  ) => void;
};

const MelaContext = React.createContext<MelaContext>(null);

export default MelaContext;
